import React from 'react';
import PropTypes from 'prop-types';

import { getFormattedCurrency } from '../../../../forms/formHelpers';
import { UNSUPPORTED_DETAIL_KEYS } from '../../budgetTrackingHelpers';

function CostTrackingAnalysisCard({ card, onClick }) {
  const isUncategorized = card.key === 'uncategorizedCosts';
  const isClickable = onClick && !UNSUPPORTED_DETAIL_KEYS.has(card.key);
  const className = [
    'cost-tracking-analysis-summary-card',
    isUncategorized && 'cost-tracking-analysis-summary-card-uncategorized',
    isClickable && 'cost-tracking-analysis-summary-card-clickable',
  ].filter(Boolean).join(' ');
  const Wrapper = isClickable ? 'button' : 'div';

  return (
    <Wrapper
      type={isClickable ? 'button' : undefined}
      className={className}
      onClick={isClickable ? () => onClick(card.key) : undefined}
    >
      <div className="cost-tracking-analysis-summary-card-title">{card.title}</div>
      <div className="cost-tracking-analysis-summary-card-row">
        <span className="cost-tracking-analysis-summary-card-label">Act:</span>
        <span className="cost-tracking-analysis-summary-card-value">
          {getFormattedCurrency(card.actual)}
        </span>
      </div>
      {!isUncategorized && (
        <div className="cost-tracking-analysis-summary-card-row">
          <span className="cost-tracking-analysis-summary-card-label">Est:</span>
          <span className="cost-tracking-analysis-summary-card-value">
            {card.hasEstimated ? getFormattedCurrency(card.estimated) : '-'}
          </span>
        </div>
      )}
      {!!card.hasEstimated && (
        <>
          <div className="cost-tracking-analysis-summary-card-bars">
            <div className="cost-tracking-analysis-summary-card-bar-wrap">
              <div
                className="cost-tracking-analysis-summary-card-bar cost-tracking-analysis-summary-card-bar-act"
                style={{ width: `${card.actPct}%` }}
              />
            </div>
            <div className="cost-tracking-analysis-summary-card-bar-label">Act</div>
            <div className="cost-tracking-analysis-summary-card-bar-wrap">
              <div
                className="cost-tracking-analysis-summary-card-bar cost-tracking-analysis-summary-card-bar-est"
                style={{ width: `${card.estPct}%` }}
              />
            </div>
            <div className="cost-tracking-analysis-summary-card-bar-label">Est</div>
          </div>
          <div
            className={`cost-tracking-analysis-summary-card-difference ${card.isFavorable ? 'cost-tracking-analysis-summary-card-difference-favorable' : 'cost-tracking-analysis-summary-card-difference-unfavorable'}`}
          >
            <span className="cost-tracking-analysis-summary-card-difference-arrow">
              {card.isFavorable ? '↓' : '↑'}
            </span>
            <span>
              {getFormattedCurrency(
                card.isFavorable ? card.difference : -card.difference,
              )}
            </span>
          </div>
        </>
      )}
      {!card.hasEstimated && !!isUncategorized && (
        <div className="cost-tracking-analysis-summary-card-bars">
          <div className="cost-tracking-analysis-summary-card-bar-wrap">
            <div
              className="cost-tracking-analysis-summary-card-bar cost-tracking-analysis-summary-card-bar-uncategorized"
              style={{ width: card.actual ? '100%' : '0%' }}
            />
          </div>
          <div className="cost-tracking-analysis-summary-card-bar-label">Act</div>
        </div>
      )}
    </Wrapper>
  );
}

CostTrackingAnalysisCard.propTypes = {
  card: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    actual: PropTypes.number,
    estimated: PropTypes.number,
    hasEstimated: PropTypes.bool,
    estPct: PropTypes.number,
    actPct: PropTypes.number,
    isFavorable: PropTypes.bool,
    difference: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func,
};

CostTrackingAnalysisCard.defaultProps = {
  onClick: null,
};

export default CostTrackingAnalysisCard;
